import { useEffect, useState } from 'react'
import { itemStatuses, firebaseCollections as collections, rentalStatuses, adjustmentStatuses, api } from 'utils/constants'
import firebase, { db }  from 'utils/firebase'
import { instance as axios }  from 'utils/api/axios/firebase'
import { useData } from 'utils/hooks'

const useCloseTicket = () => {
  const { rental, user, dispatchNotification } = useData()
  const [extended, setExtended] = useState(false);
  const [loading, setLoading] = useState(false);
  const [extensionOnly, setExtensionOnly] = useState(false);
  const [open, setOpenCloseTicket] = useState(false);
  const setOpen = () => setOpenCloseTicket(true);
  const setClose = () => {
    setExtended(false)
    setOpenCloseTicket(false);
  }
  const onExtension = (checked) => setExtended(checked)



  const onCloseTicket = async () => {
    let batch = db.batch();
    let inventoryAjusment = []
    try {
      setLoading(true)
    let rentalRef = db.collection(collections.orders).doc(rental?.id)
    batch.update(rentalRef, {
      status: extended ? rentalStatuses.extended : rentalStatuses.closed,
      closedDate: firebase.firestore.Timestamp.now(),
      rentalClosedBy: { uid: user.uid ?? "", name: user.name ?? '', email: user.email }
    })

    rental?.items.forEach(item => {
      let itemRef = rentalRef.collection(collections.items).doc(item?.id)
      if ((item?.returnedStatus === itemStatuses.returned || rental?.status === rentalStatuses.new) && item?.catalogObjectId) {
        inventoryAjusment.push({
          catalogObjectId: item?.catalogObjectId,
          locationId: rental?.startStore?.id ?? rental?.originStoreId,
          quantity: parseInt(item?.quantity, 10),
          type: adjustmentStatuses.return
        })
      }
      if (extended) {
        batch.update(itemRef, {
          returnedStatus: itemStatuses.extended
        })
      } else if (rental?.status === rentalStatuses.new) {
        batch.update(itemRef, {
          returnedStatus: itemStatuses.returned
        })
  
      }
    })
      if (inventoryAjusment.length > 0) {
        await axios.post(api.batchInventory, { adjustments: inventoryAjusment })
      }
      await batch.commit()
      dispatchNotification({ message: 'Closed Rental successfully', type: 'success' })
      setClose()
    } catch (e) {
      console.log(e)
      dispatchNotification({ message: 'An error occured', type: 'error' })
    }
    finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    let hasOutwithCustomer = rental?.items?.filter(item => item.returnedStatus === itemStatuses.outWithCustomer).length > 0
    setExtensionOnly(hasOutwithCustomer)
  }, [rental])

  return { open, setOpen, setClose, onExtension, extensionOnly, onCloseTicket, extended, loading }
}

export default useCloseTicket
